document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.menu-drawer__search').forEach((drawerSearch) => {
    const searchInput = drawerSearch.querySelector('.search__input');
    const resetButton = drawerSearch.querySelector('.reset__button');
    const searchForm = drawerSearch.querySelector('form');
    const drawerDetails = drawerSearch.closest('details');

    if (!searchInput || !searchForm) return;

    const updateResetButton = () => {
      if (!resetButton) return;
      resetButton.classList.toggle('hidden', searchInput.value.length === 0);
    };

    searchInput.addEventListener('input', updateResetButton);
    searchForm.addEventListener('reset', () => {
      requestAnimationFrame(updateResetButton);
    });

    searchForm.addEventListener('submit', (event) => {
      if (searchInput.value.trim()) return;

      event.preventDefault();
      searchInput.focus();
    });

    document.addEventListener('keydown', (event) => {
      if (!drawerDetails?.open || event.key !== 'Tab') return;

      const focusable = Array.from(drawerDetails.querySelectorAll(
        'summary, a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), ' +
        'textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter((element) => {
        const style = getComputedStyle(element);

        return element.getClientRects().length > 0 &&
          style.visibility !== 'hidden' &&
          style.display !== 'none' &&
          !element.closest('[hidden]');
      });

      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const active = document.activeElement;

      if (!drawerDetails.contains(active)) {
        event.preventDefault();
        first.focus();
      } else if (event.shiftKey && active === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus();
      }
    });

    document.addEventListener('keyup', (event) => {
      if (event.key !== 'Escape' || !drawerDetails?.open) return;

      const toggle = drawerDetails.querySelector(':scope > summary');

      if (toggle?.getAttribute('aria-expanded') === 'false') {
        requestAnimationFrame(() => toggle.focus());
      }
    });

    updateResetButton();
  });
});
